import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import userInfo from "utils/userInfo";
import styles from "./BottomNav.module.scss";

import home from "assets/side_pane_new_icons/home.svg";
import task from "assets/side_pane_new_icons/note.svg";
import registration from "assets/side_pane_new_icons/createuser.svg";
import table from "assets/side_panel_icons/tabel.png";

const LANGUAGES = [
  { code: 'ru', flag: '🇷🇺', label: 'Русский' },
  { code: 'ky', flag: '🇰🇬', label: 'Кыргызча' },
  { code: 'uz', flag: '🇺🇿', label: 'O\u02bbzbekcha' },
  { code: 'en', flag: '🇬🇧', label: 'English' },
  { code: 'tr', flag: '🇹🇷', label: 'Türkçe' },
  { code: 'kk', flag: '🇰🇿', label: 'Қазақша' },
];

export default function MenuDrawerMobile() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = userInfo();
  const [langOpen, setLangOpen] = useState(false);

  const switchLanguage = (code) => {
    const combo = document.querySelector('.goog-te-combo');
    if (combo) {
      combo.value = code;
      combo.dispatchEvent(new Event('change'));
    }
    setLangOpen(false);
  };

  const items = [
    user?.is_personal_kyrgyzkomur && { path: '/employee-card/', label: 'Главная', icon: home, match: 'employee-card' },
    !user?.is_personal_kyrgyzkomur && { path: '/report-card/', label: 'Перевозки', icon: table, match: 'report' },
    user?.is_admin_of && { path: '/adminpanel/', label: 'Панель', icon: task, match: 'adminpanel' },
    user?.is_admin_of && { path: '/register_person', label: 'Создать', icon: registration, match: 'register_person' },
    user?.is_report_of && { path: '/reports', label: 'Отчёты', icon: task, match: 'reports' },
  ].filter(Boolean);

  return (
    <>
      {/* Language modal */}
      {langOpen && (
        <>
          <div className={styles.langOverlay} onClick={() => setLangOpen(false)} />
          <div className={styles.langSheet} translate="no">
            <div className={styles.langSheetHandle} />
            <p className={styles.langSheetTitle}>Выберите язык</p>
            <div className={styles.langList}>
              {LANGUAGES.map((l) => (
                <button key={l.code} className={styles.langOption} onClick={() => switchLanguage(l.code)}>
                  <span className={styles.langFlag} translate="no">{l.flag}</span>
                  <span className={styles.langLabel} translate="no">{l.label}</span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}

      <nav className={styles.bottomNav} translate="no">
        {items.map((item) => {
          const isActive = location.pathname.includes(item.match);
          return (
            <button
              key={item.path}
              className={`${styles.navItem}${isActive ? ' ' + styles.active : ''}`}
              onClick={() => navigate(item.path)}
            >
              <img src={item.icon} alt="" className={styles.icon} />
              <span className={styles.label}>{item.label}</span>
            </button>
          );
        })}
        <button className={styles.navItem} onClick={() => setLangOpen(v => !v)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:22,height:22,flexShrink:0,color:'#9ca3af'}}>
            <circle cx="12" cy="12" r="10"/>
            <line x1="2" y1="12" x2="22" y2="12"/>
            <path d="M12 2a15.3 15.3 0 0 1 0 20a15.3 15.3 0 0 1 0-20z"/>
          </svg>
          <span className={styles.label}>Язык</span>
        </button>
      </nav>
    </>
  );
}

